// LeaderboardUserCards.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LeaderboardUserCard from '../container/LeaderboardUserCard.js';
import getLeaderboardUserCardsLayout from '../resource/getLeaderboardUserCardsLayout.js';
import {
  USER_CARD_WIDTH,
  USER_CARD_HORIZONTAL_GAP,
  USER_CARDS_CONTAINER_HORIZONTAL_GAP,
} from '../resource/leaderboardConstants.js';

const style = {};
const { amountPerRow, isCentered } = getLeaderboardUserCardsLayout();

// TODO: need refactor
if (isCentered) {
  style[
    'gridTemplateColumns'
  ] = `repeat(${amountPerRow}, ${USER_CARD_WIDTH}px)`;
  style['justifyContent'] = 'center';
} else {
  style[
    'gridTemplateColumns'
  ] = `repeat(auto-fill, minmax(${USER_CARD_WIDTH}px, 1fr))`;
}

export class LeaderboardUserCards extends React.PureComponent {
  state = { isClient: false };
  nextTick = null;
  componentDidMount() {
    const { fetchLeaderboardUsers, isActive, isIntersecting, region } =
      this.props;
    const shouldFetchData = isActive && isIntersecting && region;
    if (shouldFetchData) {
      this.nextTick = setTimeout(() => {
        this.setState({ isClient: true });
        fetchLeaderboardUsers();
      }, 0);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      isActive: prevIsActive,
      isIntersecting: prevIsIntersecting,
      isAuthed: prevIsAuthed,
      shouldRefresh: prevShouldRefresh,
      region: prevRegion,
      userIds: prevUserIds,
    } = prevProps;
    const {
      fetchLeaderboardUsers,
      isActive,
      isIntersecting,
      isAuthed,
      shouldRefresh,
      region,
      userIds,
      updateHeight,
    } = this.props;
    const shouldFetchData =
      isActive &&
      isIntersecting &&
      region &&
      (isActive !== prevIsActive ||
        isIntersecting !== prevIsIntersecting ||
        isAuthed !== prevIsAuthed ||
        region !== prevRegion);

    if (shouldFetchData) {
      clearTimeout(this.nextTick);
      this.nextTick = setTimeout(() => {
        this.setState({ isClient: true });
        fetchLeaderboardUsers();
      }, 0);
    }

    if (
      userIds.length !== prevUserIds.length ||
      this.state.isClient !== prevState.isClient
    ) {
      updateHeight();
    }

    if (shouldRefresh && isActive && shouldRefresh !== prevShouldRefresh) {
      fetchLeaderboardUsers();
    }
  }
  componentWillUnmount() {
    clearTimeout(this.nextTick);
  }
  render() {
    const { userIds, category, isIntersecting, region, range } = this.props;
    const { isClient } = this.state;
    const shouldShowPlaceholder = userIds.length === 0 || !isIntersecting;
    const totalUserCardAmount = isClient ? amountPerRow * 2 : 0;

    return (
      <StyledHomeLeaderboardUserCards>
        <Users style={style}>
          {shouldShowPlaceholder
            ? Array(totalUserCardAmount)
                .fill(null)
                .map((userId, index) => {
                  return (
                    <LeaderboardUserCard
                      key={index}
                      userId={userId}
                      index={index}
                      category={category}
                    />
                  );
                })
            : userIds.slice(0, totalUserCardAmount).map((userId, index) => {
                return (
                  <LeaderboardUserCard
                    key={userId}
                    userId={userId}
                    index={index}
                    category={category}
                    region={region}
                    range={range}
                  />
                );
              })}
        </Users>
      </StyledHomeLeaderboardUserCards>
    );
  }
}

LeaderboardUserCards.propTypes = {
  category: PropTypes.string,
  region: PropTypes.string,
  range: PropTypes.string,
  userIds: PropTypes.array,
  fetchLeaderboardUsers: PropTypes.func,
  isActive: PropTypes.bool,
  isIntersecting: PropTypes.bool,
  isAuthed: PropTypes.bool,
  shouldRefresh: PropTypes.bool,
  updateHeight: PropTypes.func,
};

LeaderboardUserCards.defaultProps = {
  category: '',
  region: null,
  range: null,
  userIds: [],
  fetchLeaderboardUsers: () => null,
  isActive: false,
  isIntersecting: false,
  isAuthed: false,
  shouldRefresh: false,
  updateHeight: () => null,
};

const StyledHomeLeaderboardUserCards = styled.div``;

const Users = styled.div`
  padding-left: ${USER_CARDS_CONTAINER_HORIZONTAL_GAP}px;
  padding-right: ${USER_CARDS_CONTAINER_HORIZONTAL_GAP}px;
  display: grid;
  grid-gap: 14px ${USER_CARD_HORIZONTAL_GAP}px;
`;

export default LeaderboardUserCards;
